<template>
  <div class="d-flex flex-grow-1 pb-1 pt-1">
    <!-- Hamburger menu button -->
    <v-btn class="menu-button ml-4" icon @click="toggleDrawer" v-if="$vuetify.breakpoint.mdAndDown">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-overlay v-model="configurator.showOverlay" :z-index="2" color="#C4A9EF"></v-overlay>
    <!-- Create New Project -->
    <newProjectDialog />
    <!-- Project Loading Dialog -->
    <projectLoadingDialog />
    <!-- Create Account Dialog -->
    <createAccountDialog />
    <!-- Login Dialog -->
    <loginDialog />
    <!-- Forgot Password Dialog -->
    <forgotPasswordDialog />
    <!-- Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      :temporary="$vuetify.breakpoint.mdAndDown"
      mobile-breakpoint="sm"
      floating
      class="sidebar elevation-0"
      color="primary"
    >
      <sidebar />
    </v-navigation-drawer>

    <v-main>
      <v-container
        class="fill-height pa-0 mainContainer mt-5 mutedWhiteBackground"
        :class="bottomMarginClass"
        :fluid="!isContentBoxed"
      >
        <v-layout>
          <slot></slot>
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import sidebar from '@/components/sidebar/Sidebar';
  import loginDialog from '@/components/authentication/LoginDialog.vue';
  import createAccountDialog from '@/components/authentication/CreateAccountDialog.vue';
  import forgotPasswordDialog from '@/components/authentication/ForgotPasswordDialog.vue';
  import newProjectDialog from '@/components/configurator/project/NewProjectDialog.vue';
  import projectLoadingDialog from '@/components/configurator/project/ProjectLoadingDialog.vue';

  export default {
    components: {
      sidebar,
      loginDialog,
      createAccountDialog,
      forgotPasswordDialog,
      newProjectDialog,
      projectLoadingDialog
    },
    data() {
      return {
        drawer: true,
        isContentBoxed: false
      };
    },
    computed: {
      ...mapState(['app', 'navigation', 'configurator']),
      bottomMarginClass() {
        if (this.$route.name === 'subsystem') {
          return 'hasBottomNavigation';
        } else {
          return '';
        }
      },
      /**
       * Controls if the navigation drawer is minified or not
       */
      mini() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return true;
          case 'sm':
            return true;
          case 'md':
            return true;
          case 'lg':
            return false;
          case 'xl':
            return false;
          default:
            return false;
        }
      }
    },
    mounted: function () {
      if (this.app.useAuthentication) {
        this.$store.dispatch('app/getUser').then(() => {
          this.$store.dispatch('configurator/getAvailableSystems');
          this.$store.dispatch('configurator/getProjectSettingDefinitions');
          this.$store.dispatch('order/getOrderList');
        });
      }
    },
    methods: {
      /**
       * Toggles the state of the drawer.
       */
      toggleDrawer() {
        this.drawer = !this.drawer;
      }
    }
  };
</script>

<style>
  .hasBottomNavigation {
    margin-bottom: 132px !important;
  }
  .mainContainer {
    border-top-left-radius: 25px;
  }
  .gradient-div {
    background: linear-gradient(to top right, #c2c2c2, rgba(143, 148, 251, 0.2));
  }
  .menu-button {
    z-index: 99;
    position: absolute;
    top: 5px;
    left: px;
  }
  .audioText {
    color: #4f8afd !important;
  }

  .audioBlue {
    background-color: #4f8afd !important;
  }

  .audioBlueBg {
    background-color: #dce8ff !important;
  }

  .audioBlueSecondary {
    background-color: rgba(79, 138, 253, 0.24) !important;
  }

  .videoText {
    color: #4630c4 !important;
  }

  .videoPurple {
    background-color: #4630c4 !important;
  }

  .videoPurpleBg {
    background-color: rgba(70, 48, 196, 0.1) !important;
  }

  .videoPurpleSecondary {
    background-color: rgba(70, 48, 196, 0.12) !important;
  }

  .lightingText {
    color: #4dcbe1 !important;
  }

  .lightingGreen {
    background-color: #4dcbe1 !important;
  }

  .lightingGreenBg {
    background-color: rgba(77, 203, 225, 0.2) !important;
  }

  .lightingGreenSecondary {
    background-color: rgba(77, 203, 225, 0.21) !important;
  }

  .link {
    cursor: pointer;
  }

  .labelColumn {
    max-width: 150px;
  }
</style>
